import { render, staticRenderFns } from "./MainTraceability.vue?vue&type=template&id=45662059"
import script from "./MainTraceability.vue?vue&type=script&lang=js"
export * from "./MainTraceability.vue?vue&type=script&lang=js"
import style0 from "./MainTraceability.vue?vue&type=style&index=0&id=45662059&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports